import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getObjectListApi } from "api/general";
import { AGENDA_TEMPLATE } from "app/utils/constants/customConstant";

const initialState = {
    agendaTemplates: [],
    agendaTemplatesLoading: false,
    agendaTemplatesSuccess: false,
    agendaTemplatesError: false,
    agendaTemplatesMessage: ''
};

export const getAgendaTemplatesAPI = createAsyncThunk("getAgendaTemplatesAPI", async (thunkAPI) => {
    try {
        const response = await getObjectListApi(AGENDA_TEMPLATE);
        return response.data;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
})

const general = createSlice({
    name: "general",
    initialState,
    reducers: {
        setAgendaTemplates: (state, action) => {
            state.agendaTemplates = action.payload;
        },
        clearAgendaTemplates: (state) => {
            state.agendaTemplates = [];
            state.agendaTemplatesLoading = false;
            state.agendaTemplatesSuccess = false;
            state.agendaTemplatesError = false;
            state.agendaTemplatesMessage = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAgendaTemplatesAPI.pending, (state) => {
                state.agendaTemplatesLoading = true;
                state.agendaTemplatesError = false;
                state.agendaTemplatesMessage = '';
            })
            .addCase(getAgendaTemplatesAPI.fulfilled, (state, action) => {
                state.agendaTemplatesLoading = false;
                state.agendaTemplatesSuccess = true;
                state.agendaTemplates = action.payload;
            })
            .addCase(getAgendaTemplatesAPI.rejected, (state, action) => {
                state.agendaTemplatesLoading = false;
                state.agendaTemplatesError = true;
                state.agendaTemplatesMessage = action.payload;
            })
    }
});

export const {
    setAgendaTemplates,
    clearAgendaTemplates
} = general.actions;

export default general.reducer;
